import { formatEstimateTime } from 'helpers/formatEstimateTime'

export default (value, formik, fieldName) => {
  formik.setFieldValue(fieldName, formatEstimateTime(String(value)))
}
